import { z } from 'zod';
// Remote MCP server (ChatGPT connector): consent page + «Conexiones MCP». Session-authenticated JSON routes only;
// the OAuth/MCP protocol endpoints are wire-format handlers in apps/api (see api-mcp.ts).
import { OkSchema } from './api.js';
import * as M from './api-mcp.js';
import { IdParam, route } from './route-def.js';

const Req = z.object({ requestId: z.string().min(16).max(128).regex(/^[A-Za-z0-9_-]+$/) });

export const mcpRoutes = {
  getOauthRequest: route({
    method: 'GET', path: '/oauth/requests/:requestId', summary: 'Solicitud de autorización de un cliente MCP (página de consentimiento)', tag: 'oauth',
    params: Req, response: M.OauthAuthorizationRequestSchema,
  }),
  approveOauthRequest: route({
    method: 'POST', path: '/oauth/requests/:requestId/approve', summary: 'Aprobar el acceso del cliente MCP (requiere platform_mcp)', tag: 'oauth',
    params: Req, response: M.OauthDecisionResultSchema,
  }),
  denyOauthRequest: route({
    method: 'POST', path: '/oauth/requests/:requestId/deny', summary: 'Rechazar el acceso del cliente MCP', tag: 'oauth',
    params: Req, response: M.OauthDecisionResultSchema,
  }),
  listMcpGrants: route({
    method: 'GET', path: '/oauth/grants', summary: 'Conexiones MCP (propias; todas para administradores de plataforma)', tag: 'oauth',
    response: M.McpGrantListSchema,
  }),
  revokeMcpGrant: route({
    method: 'DELETE', path: '/oauth/grants/:grantId', summary: 'Revocar una conexión MCP (invalida sus tokens de inmediato)', tag: 'oauth',
    params: z.object({ grantId: IdParam }), response: OkSchema,
  }),
};
